interface RuntimeEnv {
  VITE_API_URL?: string;
  VITE_GOOGLE_CLIENT_ID?: string;
}

interface GoogleTokenResponse {
  access_token?: string;
  error?: string;
  error_description?: string;
}

interface GoogleTokenClient {
  requestAccessToken(overrides?: { prompt?: string }): void;
}

interface GoogleAccountsOAuth2 {
  initTokenClient(config: {
    client_id: string;
    scope: string;
    callback: (response: GoogleTokenResponse) => void;
    error_callback?: (error: { type: string; message?: string }) => void;
  }): GoogleTokenClient;
}

declare global {
  interface Window {
    __ENV__?: RuntimeEnv;
    google?: {
      accounts: {
        oauth2: GoogleAccountsOAuth2;
      };
    };
  }
}

function isUnresolved(value: string | undefined): boolean {
  if (!value) return true;
  return value.startsWith('${') && value.endsWith('}');
}

function read(key: keyof RuntimeEnv): string | undefined {
  const runtime = typeof window !== 'undefined' ? window.__ENV__?.[key] : undefined;
  if (runtime && !isUnresolved(runtime)) return runtime;
  const build = import.meta.env[key];
  return typeof build === 'string' && build.length > 0 ? build : undefined;
}

export const env = {
  apiUrl: read('VITE_API_URL') ?? '',
  googleClientId: read('VITE_GOOGLE_CLIENT_ID') ?? '',
};
